import { ErrorMetadata, KazooError } from "@kazoohr/types";
import { IKazooErrorConstructable, initializeError } from "@kazoohr/types";

export function assertIsNotNullOrUndefined<T>(
  parameter: T | undefined | null,
  options: {
    message: string;
    errorMetadata?: {} & ErrorMetadata;
    error?: IKazooErrorConstructable;
  } = {
    message: "Expected a non null value.  Received null or undefined.",
    errorMetadata: {},
  }
): asserts parameter is T {
  if (parameter === undefined || parameter === null) {
    throw initializeError(
      options.error || KazooError,
      options.message,
      options.errorMetadata
    );
  }
}
